import React from 'react';

import '../../css/Loader.css';

export const Loader = () => {
  return <div className="Loader">
    <div className="Loader--layer Loader--layer-1" />
    <div className="Loader--layer Loader--layer-2" />
    <div className="Loader--layer Loader--layer-3" />
    <div className="Loader--layer Loader--layer-4" />
    <div className="Loader--layer Loader--layer-5" />
    <div className="Loader--layer Loader--layer-6" />
    <div className="Loader--layer Loader--layer-7" />
  </div>
}
